<template>
    <q-select filled v-model="type" :options="types" label="Tipo de Operación" @update:modelValue="selectTurnType"
        :dense="true" :disable="disable" />
</template>


<script lang="ts">
import { defineComponent, reactive, toRefs, watch } from "vue";

import { OptionDto } from "@/dtos";
import { getHistoricOperationOptions } from "@/helpers/options";

interface Props {
    value?: string;
    disable?: boolean;
    clear?: boolean;
}
export default defineComponent({
    name: 'TypeOperationSelectComponent',
    props: {
        value: { type: String },
        disable: {
            type: Boolean,
            default: false
        },
        clear: { type: Boolean }
    },
    setup(props: Props, { emit }) {
        const data = reactive({
            type: '',
            types: getHistoricOperationOptions()
        });

        const selectTurnType = (option: OptionDto) => {
            emit('type_operation_selected', option);
        }

        watch([() => props.clear], ([oldClear],[newClear]) => {
            if (newClear != oldClear) {
                data.type = '';
                return;
            }
        });

        return {
            ...toRefs(data),
            selectTurnType
        }
    },
})
</script>
